import styled from 'styled-components';

import colors from 'utils/colors';

export const TopLevelNav = styled.nav`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
`;

export const NavItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &:before {
    content: '';
    display: block;
    height: 40px;
    width: 0px;
    border-right: 1px solid ${colors.darkGrey10};
  }

  &:last-child {
    &:after {
      content: '';
      display: block;
      height: 40px;
      width: 0px;
      border-right: 1px solid ${colors.darkGrey10};
    }
  }
`;

export const NavLink = styled.button<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 38px;
  text-decoration: none;
  background-color: transparent;
  border: none;

  font-family: inherit;
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: -0.4px;

  color: ${props => {
    const { isActive } = props;
    return isActive ? colors.orange : colors.blueGrey;
  }};

  :focus-visible {
    outline: none;
  }

  svg {
    margin-left: 1rem;

    path {
      fill: ${props => {
        const { isActive } = props;
        return isActive ? colors.orange : colors.blueGrey;
      }};
    }
  }

  :hover,
  :focus {
    cursor: pointer;

    color: ${colors.orange};

    svg {
      path {
        fill: ${colors.orange};
      }
    }
  }

  &[aria-expanded="true"] {
    svg {
      transform: rotate(180deg);
    }
  }
`;

export const LinkText = styled.span`
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: -0.4px;
`;
